<template>
    <div v-if="parseFloat(pointsBalanceWorth) > 0">
        <div class="row" :class="dynamicStyles" >
            <div class="col-md-6 col-sm-12 col-xs-12">
                <div v-if="!loyaltyRedeemed" class="mb-3">
                    <strong>
                        I want to pay with my Loyalty Points <br>
                    </strong>
                </div>
                <div v-if="loyaltyRedeemed" class="text-white">
                    Total of {{ this.currency }} {{ this.amount_redeem }} has been paid using Loyalty Points
                </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12" v-if="!loyaltyRedeemed">
                <label class="switch">
                    <input type="checkbox" v-model="loyaltyChecked">
                    <span class="slider"></span>
                </label>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12" v-if="loyaltyChecked && step=='initiate'">
                <div class="form-group">
                    <label for="amount_redeem">Amount to Redeem in {{ this.currency }}: <span style="color:red">*</span></label>
                    <input type="text" v-model="amount_redeem" class="form-control" id="amount_redeem" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12" v-if="loyaltyChecked && step=='initiate'">
                <button class="btn_confirm btn btn-orange-solid" @click.prevent="initiateRedemption">
                    Initiate Redemption
                </button>
            </div>
            <div class="col-md-6 col-sm-12 col-xs-12" v-if="loyaltyChecked && step=='complete'">
                <div class="form-group">
                    <label for="otp">Enter Confirmation Code: <span style="color:red">*</span></label>
                    <input type="text" v-model="otp" class="form-control" id="otp" />
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12" v-if="loyaltyChecked && step=='complete'">
                <button class="btn_confirm btn btn-orange-solid" @click.prevent="completeRedemption">
                    Confirm Redemption
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import reusableData from '../mixins/reusableData'
import { EventBus } from '../mixins/eventBus'

export default {
    props: ['phonenumber', 'propertyid', 'paytotal', 'currency', 'res_nonres'],
    beforeMount: async function () {
        this.getPointsBalance()
    },
    data () {
        return {
            pointsBalance: 0,
            pointsBalanceWorth: 0,
            loyaltyChecked: false,
            amount_redeem: 0,
            loyaltyRedeemed: false,
            tracking_id: '',
            otp: '',
            step: 'initiate',
            dynamicStyles: 'bg-white p-3'
        }
    },
    methods: {
        async getPointsBalance() {
            const postData = {
                phonenumber: this.phonenumber
            }
            const postDataJson = JSON.stringify(postData)
            const authDetails = await this.getAuthentication()
            const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
            try {
                const formData = new FormData()
                formData.append('pid', this.propertyid)
                formData.append('consumer_key', authDetails.consumerKey)
                formData.append('data', encryptedData)
                formData.append('option', 'com_goreserva_psearch')
                formData.append('task', 'api.getLoyaltyPointsBalance')
                const response = await this.axios.post(authDetails.posturl, formData)
                if (response) {
                    let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
                    data = JSON.parse(data)
                    if (data) {
                        this.pointsBalance = data.data.balance
                        this.pointsBalanceWorth = data.data.value
                    }
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        async initiateRedemption() {
            if (this.amount_redeem <= 0 || this.amount_redeem > this.paytotal) {
                console.log('the amount is greater than cart totals')
                return false
            }
            const postData = {
                amount: this.amount_redeem,
                phonenumber: this.phonenumber,
                source: '1',
                currency: this.currency
            }
            const postDataJson = JSON.stringify(postData)
            const authDetails = await this.getAuthentication()
            const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
            try {
                const formData = new FormData()
                formData.append('pid', this.propertyid)
                formData.append('consumer_key', authDetails.consumerKey)
                formData.append('data', encryptedData)
                formData.append('option', 'com_goreserva_psearch')
                formData.append('task', 'api.initiateRedemption')
                const response = await this.axios.post(authDetails.posturl, formData)
                if (response) {
                    let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
                    data = JSON.parse(data)
                    if (data.status == 200) {
                        this.tracking_id = data.data.tracking_id
                        this.step = 'complete'
                    }
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        async completeRedemption() {
            if (this.tracking_id.length == 0 || this.otp.length == 0) { //don't proceed if there's no tracking id and otp
                return false
            }
            const postData = {
                tracking_id: this.tracking_id,
                otp: this.otp,
            }
            const postDataJson = JSON.stringify(postData)
            const authDetails = await this.getAuthentication()
            const encryptedData = this.CryptoJSAesEncrypt(authDetails.passkey, postDataJson)
            try {
                const formData = new FormData()
                formData.append('pid', this.propertyid)
                formData.append('consumer_key', authDetails.consumerKey)
                formData.append('data', encryptedData)
                formData.append('option', 'com_goreserva_psearch')
                formData.append('task', 'api.completeLoyaltyRedemption')
                const response = await this.axios.post(authDetails.posturl, formData)
                if (response) {
                    let data = this.CryptoJSAesDecrypt(authDetails.passkey, response.data.er)
                    data = JSON.parse(data)
                    if (data.status === 200) {
                        // this.$store.state.board.totalAmountPayable.res = parseFloat(this.$store.state.board.totalAmountPayable.res) - postData.amount
                        this.loyaltyRedeemed = true
                        let amountRedeemed = parseFloat(this.amount_redeem)
                        amountRedeemed = amountRedeemed.toFixed(2)
                        let loyalty_pay_info = {
                            redeem_amount: amountRedeemed,
                            message: "Loyalty was used to pay for this booking"
                        }
                        let totalsUpdate = {}
                        totalsUpdate.res = this.res_nonres == 'res' ? amountRedeemed : 0
                        totalsUpdate.nonres = this.res_nonres == 'nonres' ? amountRedeemed : 0
                        this.$store.commit('updateLoyaltyDetails', loyalty_pay_info)
                        this.$store.commit('deductRedeemedAmountFromTotals', totalsUpdate)
                        this.updateLoyaltyPayDetails(amountRedeemed)
                        this.dynamicStyles = 'bg-success p-3'
                        this.step = 'completed'
                    }
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        async getAuthentication () {
        try {
            const configUrl = process.env.CONFIG_URL['live_url']
            const key = process.env.PMS_KEY['key']
            const config = {
            headers: { 'Accept': 'application/json' }
            }
            const payload = {
            'property_id': this.propertyid,
            'api': this.type
            }
            const configRes = await this.$http.post(configUrl, payload, config)
            if (configRes.status === 200) {
            let configData = this.CryptoJSAesDecrypt(key, configRes.data.property_details)
            configData = JSON.parse(configData)
            const passkey = configData[0].val_ptoken// process.env.SECRET_KEY[this.propertyid].key
            let consumerKey = configData[0].val_reserveport_secret_key// process.env.CONSUMER_KEY[this.propertyid].key
            const details = JSON.parse(configData[0].add_details)
            let fetchUrl = details.url
            const posturl = `${fetchUrl}/index.php`
            const configDetails = {
                'passkey': passkey,
                'consumerKey': consumerKey,
                'posturl': posturl
            }
            return configDetails
            }
        } catch (error) {
            console.log(error)
        }
        },
        updateLoyaltyPayDetails (amountRedeemed) {
            EventBus.$emit('updateLoyaltyPayDetails', amountRedeemed)
        }
    },
    mixins: [reusableData]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/loyalty/index.vue